// gatsby-browser.js
import React from 'react'
import { Auth0Provider } from '@auth0/auth0-react'
import { navigate } from 'gatsby'

const packageJson = require('./package.json')


const audience = process.env.GATSBY_AUTH0_AUDIENCE || 'https://krane-dev.orikami.tech'
const onRedirectCallback = (appState) => {
  // Use Gatsby's navigate method to replace the url
  navigate(appState?.returnTo || '/', { replace: true })
}

export const wrapRootElement = ({ element }) => {
  const appVersion = packageJson.version

  console.info(`v${appVersion}`)
  /* <div style={{ position: 'fixed', width: '65px', height: '25px', zIndex: 1300, bottom: 0 }}>v{appVersion}</div> */

  console.info(`Auth0 domain is ${process.env.GATSBY_AUTH0_DOMAIN}`)
  console.info(`Auth0 client is ${process.env.GATSBY_AUTH0_CLIENT_ID}`)
  console.info(`Auth0 redirect uri is ${process.env.GATSBY_AUTH0_REDIRECT_URI}`)
  console.info(`Audience is ${audience}`)

  return (
    <Auth0Provider
      domain={process.env.GATSBY_AUTH0_DOMAIN || 'krane-dev.eu.auth0.com'}
      clientId={process.env.GATSBY_AUTH0_CLIENT_ID || 'KmrdZPzPG1zSsrZ7dFPnEN0TvrzfIN0D'}
      redirectUri={process.env.GATSBY_AUTH0_REDIRECT_URI || 'http://localhost:8000/api/callback'}
      // scope={'openid email profile'}
      // {...(audience && { audience })}
      onRedirectCallback={onRedirectCallback}
    >
      {element}
    </Auth0Provider>
  )
}
